module.exports = __webpack_public_path__ + "static/media/mobile_instagram_display.445654e8.png";